import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbCarouselModule, NgbModalModule, NgbModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { WebcamModule } from 'ngx-webcam';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DashboardComponent } from './dashboard';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { AbilityModule } from '@casl/angular';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DetailDrawerComponent } from './detail-drawer';
import { TableComponent } from './table';
import { PipesModule } from './pipes/pipes.module';
import { QrModalComponent } from './qr-modal';
import { AccordianComponent } from './accordian';
import { NavHeaderComponent } from './nav-header';
import { AvatarComponent } from './avatar';
import { MappingComponent } from './mapping';
import { ChannelDetailDrawerComponent } from './channel-detail-drawer';
import { DialogComponent } from './dialog';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
//QR Generating Module
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { VimeModule } from '@vime/angular';
import { NgxViewerModule } from 'ngx-viewer';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { ChannelDetailUpdateDrawerComponent } from './channel-detail-update-drawer';
import { ImageUploaderComponent } from './image-uploader';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FlagComponent } from './flag';
import { TagComponent } from './tag';
import { CommentComponent } from './comment';
import { IntakeDetailDrawerComponent } from './intake-detail-drawer';
import { VideoPlayerComponent } from './video-player';
import { CollectionComponent } from './collection';
import { AdvancedFilterComponent } from './advanced-filter';
import { MultiselectAutocompleteComponent } from './multiselect-autocomplete';
import { MapAutocompleteComponent } from './map-autocomplete';
import { MomentFilterAutocompleteComponent } from './moment-filter-autocomplete';
import { AsyncFilterAutocompleteComponent } from './async-filter-autocomplete';
import { DurationPickerComponent } from './duration-picker';
import { CollectibleTypeComponent } from './collectible-type';
import { IconToggleComponent } from './icon-toggle';
import { ContactInfoComponent } from './contact-info';
import { ReportDetailsComponent } from './report-details';
import { NgxLoadingModule } from 'ngx-loading';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';

// import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { TourNgBootstrapModule } from 'ngx-ui-tour-ng-bootstrap';
import { JottoOnboardComponent } from './jotto-onboard';

// import { TourNgxPopperModule } from 'ngx-tour-ngx-popper';
import { NGX_MAT_DATE_FORMATS, NgxMatDateFormats, NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgImgEditorModule } from 'ng-img-editor';
import { IntlPhonenumberComponent } from './intl-phonenumber';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DialogModule, DialogService } from '@ngneat/dialog';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CUSTOM_DIRECTIVES } from './directives';
import { NgxEditorModule } from 'ngx-editor';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TextEditorComponent } from './text-editor';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxMatTimepickerModule as NgxMatTimepickerModule2 } from 'ngx-mat-timepicker';
import { NgChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts-lazy';
import { ActionDialogComponent } from './action-dialog';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { NotificationModalComponent } from './notification-modal';
import { TranscriptionRowComponent, TranscriptionTooltipComponent } from './transcription-row';
import { NotificationPreviewComponent } from './notification-preview';
import { ChannelPreviewComponent } from './channel-preview';
import { ButtonIconComponent } from './button-icon';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { IgxCarouselModule, IgxSliderModule } from 'igniteui-angular';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { NotificationsResponseComponent } from './notifications-response';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { ChannelFeedComponent } from './channel-feed';
import { VideoUploaderComponent } from './video-uploader';
import { CdTimerModule } from 'angular-cd-timer';
import { QRCodeModule } from 'jotto-qrcode';
import { TextResponseComponent } from './text-response';
import { AudioRecorderComponent } from './audio-recorder';
import { VideoRecorderComponent } from './video-recorder';
import { LoadingComponent } from './loading';
import { ChannelActivityComponent, MapsComponent, PostsComponent, ResponsesComponent, SentimentPieComponent, WordCloudComponent, DashboardFilterComponent, TrafficComponent, TagCloudComponent, FollowChartComponent } from './analytics';
import { Error404Component, Error500Component } from './errors';
import { CtaComponent, ModalActionComponent, ResponseActionsComponent, TogglerComponent } from './web';
import { ContextmenuComponent } from './contextmenu';
// import { ContextMenuModule } from 'ngx-contextmenu';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { SentimentAnalysisComponent } from './sentiment-analysis/sentiment-analysis.component';
import { LineComponent } from './graphs/line/line.component';
import { AudioVideoBarComponent } from './graph/audio-video-bar/audio-video-bar.component';
import { ResponseLengthBarComponent } from './graph/response-length-bar/response-length-bar.component';
import { TbaMapsComponent } from './analytics';
import { TbaReportsLineComponent } from './analytics';
import { TbaBarsComponent } from './analytics/tba-bars/tba-bars.component';
export function playerFactory() {
	return player;
}

export const EXTERNAL_MODULES = [
	CommonModule,
	RouterModule,
	// Layout
	LayoutModule,
	FlexLayoutModule,
	PortalModule,
	AbilityModule,
	// Forms
	FormsModule,
	ReactiveFormsModule,
	// Pipes
	PipesModule,
	// Ng Bootstrap
	NgbModule,
	// Accordion
	CdkAccordionModule,
	DragDropModule,
	// Angular Material
	A11yModule,
	ClipboardModule,
	CdkStepperModule,
	CdkTableModule,
	CdkTreeModule,
	DragDropModule,
	MatAutocompleteModule,
	MatBadgeModule,
	MatBottomSheetModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatCardModule,
	MatCheckboxModule,
	MatChipsModule,
	MatStepperModule,
	MatDatepickerModule,
	MatDialogModule,
	MatDividerModule,
	MatExpansionModule,
	MatGridListModule,
	MatIconModule,
	MatInputModule,
	MatListModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatRippleModule,
	MatSelectModule,
	MatSidenavModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatToolbarModule,
	MatTooltipModule,
	MatTreeModule,
	PortalModule,
	ScrollingModule,
	MatToolbarModule,
	MatInputModule,
	MatCheckboxModule,
	MatCardModule,
	MatMenuModule,
	MatChipsModule,
	MatIconModule,
	MatButtonModule,
	MatDialogModule,
	MatDatepickerModule,
	// MatMomentDateModule,
	MatButtonToggleModule,
	MatNativeDateModule,
	MatTableModule,
	MatPaginatorModule,
	MatSortModule,
	MatDividerModule,
	MatSlideToggleModule,
	MatSelectModule,
	MatOptionModule,
	MatProgressSpinnerModule,
	MatSidenavModule,
	MatTabsModule,
	MatTooltipModule,
	MatListModule,
	MatRippleModule,
	ClipboardModule,
	MatExpansionModule,
	MatSnackBarModule,
	MatAutocompleteModule,
	MatGridListModule,
	MatTabsModule,
	MatProgressBarModule,

	// Search Fields
	Ng2SearchPipeModule,

	// Quick Response Code
	NgxQRCodeModule,
	QRCodeModule,

	// Image viewer
	NgxViewerModule,

	// Image Cropper
	ImageCropperModule,

	// VideoPlayer
	VimeModule,

	// Emoji picker
	PickerModule,

	// DateTime Picker
	NgxMatDatetimePickerModule,
	NgxMatTimepickerModule,
	NgxMatNativeDateModule,
	// NgxMatMomentModule,
	NgImgEditorModule,
	CKEditorModule,
	NgxMatTimepickerModule2,

	// Charts Modules
	NgChartsModule,
	NgApexchartsModule,

	// Image Resizer
	Ng2ImgMaxModule,

	// Responsive Carousel
	IvyCarouselModule,
	NgbCarouselModule,
	IgxCarouselModule,
	IgxSliderModule,

	// Barcode Scanner
	NgxScannerQrcodeModule,
	CdTimerModule,

	// Web Camera
	WebcamModule,
];

const INTL_DATE_INPUT_FORMAT = {
	year: 'numeric',
	month: 'numeric',
	day: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
};

const MAT_DATE_FORMATS: NgxMatDateFormats = {
	parse: {
		dateInput: INTL_DATE_INPUT_FORMAT,
	},
	display: {
		dateInput: INTL_DATE_INPUT_FORMAT,
		monthYearLabel: { year: 'numeric', month: 'short' },
		dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
		monthYearA11yLabel: { year: 'numeric', month: 'long' },
	},
};

@NgModule({
	imports: [
		...EXTERNAL_MODULES,
		NgxIntlTelInputModule,
		TooltipModule.forRoot(),
		DialogModule.forRoot(),
		SweetAlert2Module.forRoot(),
		FontAwesomeModule,
		SweetAlert2Module.forRoot(),
		NgxLoadingModule.forRoot({}),
		LottieModule.forRoot({ player: playerFactory }),
		PasswordStrengthMeterModule.forRoot(),
		// NgxAwesomePopupModule.forRoot(),
		// DialogConfigModule.forRoot(),
		// ConfirmBoxConfigModule.forRoot(),
		// ToastNotificationConfigModule.forRoot(),
		// TourMatMenuModule.forRoot(),
		TourNgBootstrapModule.forRoot(),
		NgxSkeletonLoaderModule,
		NgbModalModule,
		NgbTooltipModule,
		NgbPopoverModule,
		ContextMenuModule,
		AgmJsMarkerClustererModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyAMT2P0L8ccFwmNKuZHtU2Yo5ErJYnXTdQ' + '&libraries=visualization',
			libraries: ['places', 'visualization'],
		}),
		NgxEditorModule.forRoot({
			locals: {
				// menu
				bold: 'Bold',
				italic: 'Italic',
				code: 'Code',
				blockquote: 'Blockquote',
				underline: 'Underline',
				strike: 'Strike',
				bullet_list: 'Bullet List',
				ordered_list: 'Ordered List',
				heading: 'Heading',
				h1: 'Header 1',
				h2: 'Header 2',
				h3: 'Header 3',
				h4: 'Header 4',
				h5: 'Header 5',
				h6: 'Header 6',
				align_left: 'Left Align',
				align_center: 'Center Align',
				align_right: 'Right Align',
				align_justify: 'Justify',
				text_color: 'Text Color',
				background_color: 'Background Color',

				// popups, forms, others...
				url: 'URL',
				text: 'Text',
				openInNewTab: 'Open in new tab',
				insert: 'Insert',
				altText: 'Alt Text',
				title: 'Title',
				remove: 'Remove',
			},
		}),
	],
	exports: [
		...EXTERNAL_MODULES,
		...CUSTOM_DIRECTIVES,
		AgmCoreModule,
		FontAwesomeModule,
		AgmJsMarkerClustererModule,
		DashboardComponent,
		DetailDrawerComponent,
		TableComponent,
		QrModalComponent,
		AccordianComponent,
		AvatarComponent,
		NavHeaderComponent,
		MappingComponent,
		ChannelDetailDrawerComponent,
		DialogComponent,
		ImageViewerComponent,
		ChannelDetailUpdateDrawerComponent,
		ImageUploaderComponent,
		FlagComponent,
		TagComponent,
		CommentComponent,
		VideoPlayerComponent,
		CollectionComponent,
		AdvancedFilterComponent,
		MultiselectAutocompleteComponent,
		MapAutocompleteComponent,
		MomentFilterAutocompleteComponent,
		AsyncFilterAutocompleteComponent,
		DurationPickerComponent,
		CollectibleTypeComponent,
		IconToggleComponent,
		ContactInfoComponent,
		ReportDetailsComponent,
		JottoOnboardComponent,
		IntlPhonenumberComponent,
		TextEditorComponent,
		ActionDialogComponent,
		NotificationModalComponent,
		NotificationPreviewComponent,
		ChannelPreviewComponent,
		ButtonIconComponent,
		NotificationsResponseComponent,
		ChannelFeedComponent,
		TranscriptionRowComponent,
		VideoUploaderComponent,
		TextResponseComponent,
		AudioRecorderComponent,
		VideoRecorderComponent,
		LoadingComponent,
		MapsComponent,
		PostsComponent,
		ChannelActivityComponent,
		ResponsesComponent,
		WordCloudComponent,
		SentimentPieComponent,
		Error500Component,
		Error404Component,
		ModalActionComponent,
		ResponseActionsComponent,
		TogglerComponent,
		CtaComponent,
		ContextmenuComponent,
		SentimentAnalysisComponent,
		LineComponent,
		TrafficComponent,
		TagCloudComponent,
		FollowChartComponent,
		AudioVideoBarComponent,
		ResponseLengthBarComponent,
		DashboardFilterComponent,
		TbaMapsComponent,
		TbaReportsLineComponent,
		TbaBarsComponent,
	],
	declarations: [
		...CUSTOM_DIRECTIVES,
		TranscriptionTooltipComponent,
		DashboardComponent,
		TranscriptionRowComponent,
		DetailDrawerComponent,
		TableComponent,
		QrModalComponent,
		AccordianComponent,
		AvatarComponent,
		NavHeaderComponent,
		MappingComponent,
		ChannelDetailDrawerComponent,
		DialogComponent,
		ImageViewerComponent,
		ChannelDetailUpdateDrawerComponent,
		ImageUploaderComponent,
		FlagComponent,
		TagComponent,
		CommentComponent,
		IntakeDetailDrawerComponent,
		VideoPlayerComponent,
		CollectionComponent,
		AdvancedFilterComponent,
		MultiselectAutocompleteComponent,
		MapAutocompleteComponent,
		MomentFilterAutocompleteComponent,
		AsyncFilterAutocompleteComponent,
		DurationPickerComponent,
		CollectibleTypeComponent,
		IconToggleComponent,
		ContactInfoComponent,
		ReportDetailsComponent,
		JottoOnboardComponent,
		IntlPhonenumberComponent,
		TextEditorComponent,
		ActionDialogComponent,
		NotificationModalComponent,
		NotificationPreviewComponent,
		ChannelPreviewComponent,
		ButtonIconComponent,
		NotificationsResponseComponent,
		ChannelFeedComponent,
		VideoUploaderComponent,
		TextResponseComponent,
		AudioRecorderComponent,
		VideoRecorderComponent,
		LoadingComponent,
		MapsComponent,
		PostsComponent,
		ChannelActivityComponent,
		ResponsesComponent,
		WordCloudComponent,
		SentimentPieComponent,
		Error500Component,
		Error404Component,
		ModalActionComponent,
		ResponseActionsComponent,
		TogglerComponent,
		CtaComponent,
		ContextmenuComponent,
		SentimentAnalysisComponent,
		LineComponent,
		TrafficComponent,
		TagCloudComponent,
		FollowChartComponent,
		AudioVideoBarComponent,
		ResponseLengthBarComponent,
		DashboardFilterComponent,
		TbaMapsComponent,
		TbaReportsLineComponent,
		TbaBarsComponent,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
	providers: [{ provide: NGX_MAT_DATE_FORMATS, useValue: MAT_DATE_FORMATS }, { provide: MAT_DIALOG_DATA, useValue: {} }, { provide: MatDialogRef, useValue: {} }, ...CUSTOM_DIRECTIVES, DialogService],
})
export class PortalsUiModule {
	constructor(library: FaIconLibrary) {
		// Add Font Awesome Library to Portals
		library.addIconPacks(fas, far, fab);
	}
}
